import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchBarItemProps } from './types';
import clsx from 'clsx';
import { Badge2 } from '@/components/design-system/atoms/badge2';
import { ReactSVG } from 'react-svg';

const SearchBarItem: React.FC<SearchBarItemProps> = ({ item, style }) => {
  const { t } = useTranslation();

  return (
    <a className={clsx(
      'searchbar-item',
      style && `searchbar-item-${style}`,
      style === 'hero' && 'border-b border-solid border-gray-200 py-3'
    )} href={item.path}>
      {item.image && (
        <img
          alt={item.name}
          src={item.image}
          width={style === 'hero' ? 40 : 44}
          height={style === 'hero' ? 40 : 44}
          className="searchbar-item-image"
        />
      )}

      {!item.image && <div className="searchbar-item-image-placeholder"></div>}

      <div className="searchbar-item-content">
        <div className="searchbar-item-name text-left">
          {item.name}
        </div>

        {item.rooms_available !== undefined && (
          <>
            {item.rooms_available > 1 && (
              <span className="searchbar-item-available-rooms text-left">
                {t('js.features.marketplace.components.room_search.rooms_text', { num_rooms: item.rooms_available })}
              </span>
            )}

            {item.rooms_available === 1 && (
              <span className="searchbar-item-available-rooms text-left">
                {t('js.features.marketplace.components.room_search.room_text')}
              </span>
            )}

            {item.rooms_available === 0 && (
              <span className="searchbar-item-no-available-rooms text-left">
                {t('js.features.marketplace.components.room_search.no_results')}
              </span>
            )}
          </>
        )}
      </div>

      {item.pre_launched && (
        <Badge2 badgeVariant="neutral" badgeSize="sm" badgeStyle="gradient">
          {t('js.features.marketplace.components.room_search.coming_soon')}
        </Badge2>
      )}

      {item.available_immediately && (
        <div className="self-center">
          <ReactSVG
            src={require(`@assets/images/marketplace/lighting_active.svg`)}
            className="searchbar-item-available-immediately"
            beforeInjection={(svg) => {
              svg.setAttribute('width', `16`);
              svg.setAttribute('height', `16`);
            }}
          />
        </div>
      )}
    </a>
  );
};

export { SearchBarItem };
